import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>צור קשר</h3>
            <address>
              <p>
                <span aria-label="טלפון">📞</span>
                <a href="tel:03-3820232" aria-label="התקשר לטלפון 03-3820232">03-3820232</a>
              </p>
              <p>
                <span aria-label="אימייל">✉️</span>
                <a href="mailto:Office@auto-cross.co.il" aria-label="שלח אימייל ל Office@auto-cross.co.il">Office@auto-cross.co.il</a>
              </p>
              <p>
                <span aria-label="כתובת">📍</span>
                התמר 3 אבן יהודה
              </p>
            </address>
          </div>
          
          <nav className="footer-section" aria-labelledby="footer-nav-title">
            <h3 id="footer-nav-title">ניווט מהיר</h3>
            <ul role="list">
              <li><Link to="/" aria-label="חזור לעמוד הבית">בית</Link></li>
              <li><Link to="/financing" aria-label="מידע על מימון">מימון</Link></li>
              <li><Link to="/service" aria-label="שירות ואחריות">שירות ואחריות</Link></li>
              <li><Link to="/about" aria-label="אודות החברה">אודותינו</Link></li>
              <li><Link to="/contact" aria-label="צור קשר עם החברה">צור קשר</Link></li>
              <li><Link to="/terms-of-use" aria-label="תנאי השימוש">תנאי שימוש</Link></li>
              <li><Link to="/privacy-policy" aria-label="מדיניות הפרטיות">מדיניות פרטיות</Link></li>
              <li><Link to="/accessibility" aria-label="הצהרת נגישות">הצהרת נגישות</Link></li>
            </ul>
          </nav>
          
          <div className="footer-section">
            <h3>עקבו אחרינו</h3>
            <div className="social-links" role="list" aria-label="קישורים לרשתות חברתיות">
              <a 
                href="https://www.facebook.com/profile.php?id=61575778435151" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="עקבו אחרינו בפייסבוק (נפתח בחלון חדש)"
                role="listitem"
              >
                <i className="fab fa-facebook" aria-hidden="true"></i>
                <span className="sr-only">פייסבוק</span>
              </a>
              <a 
                href="https://www.instagram.com/autocrossltd/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="עקבו אחרינו באינסטגרם (נפתח בחלון חדש)"
                role="listitem"
              >
                <i className="fab fa-instagram" aria-hidden="true"></i>
                <span className="sr-only">אינסטגרם</span>
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="עקבו אחרינו בלינקדאין (נפתח בחלון חדש)"
                role="listitem"
              >
                <i className="fab fa-linkedin" aria-hidden="true"></i>
                <span className="sr-only">לינקדאין</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} auto-cross. כל הזכויות שמורות.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 